module.exports = __webpack_public_path__ + "assets/img/14.7d545f36.png";